import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Dispositivos from './pages/Dispositivos';

import Usuarios from './pages/Usuarios';
import Licencias from './pages/Licencias';
import Auditoria from './pages/Auditoria';
import Layout from './components/Layout';
import LoadingSpinner from './components/LoadingSpinner';

function AppContent() {
  const { usuario, cargando } = useAuth();

  if (cargando) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/login" 
          element={usuario ? <Navigate to="/dashboard" replace /> : <Login />} 
        />
        
        {usuario ? (
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="dispositivos" element={<Dispositivos />} />
            <Route path="licencias" element={<Licencias />} />
            {usuario.rol === 'admin' && (
              <Route path="usuarios" element={<Usuarios />} />
            )}
            {[6, 7].includes(usuario.id) && (
              <Route path="auditoria" element={<Auditoria />} />
            )}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App; 